<template>
    <div class="header">
        <!-- <div class="headerImg"></div>
        <div style="width:100%;"> -->
            <div class="headerDiv">
                <div class="login">
                    <img src="../../assets/images/logo.png" alt="">
                    <span>云南曲靖陆良彩色沙林智慧景区</span>  
                    <p></p>
                </div>
                <div class="title">
                    <p>
                        <router-link to="/">
                            <i class="iconfont icon-zhuye"></i>返回首页
                        </router-link>
                    </p>
                    <span @click="clickOrderList">
                        <i class="iconfont icon-huabanfuben"></i>我的订单
                    </span>
                    <div></div>
                </div>
            </div>
        <!-- </div> -->
    </div>
</template>


<script>
import api from "@/api/myOrder.js";
import store from "@/vuex/store";
    export default {
        data() {
            return {
                
            }
        },
        store,
        methods:{
            clickOrderList(){
                api.orderList({}).then(Response=>{
                    console.log(Response)
                    this.$router.push('/myOrder')
                    // this.reload();
                }).catch(error=>{
                    console.log(error)
                }) 
            }
        }
    }
</script>

<style lang="stylus" scoped>
.header{ 
    // background: url(../../assets/images/top-back.png);
    background: url(../../assets/images/img2.png) no-repeat;
    width: 100%;
    height: 316px;
    background-size: 100%;
    color: #fff;
    // .headerImg{
    //     background: url(../../assets/images/beijing1_01.png);
    // }
    .headerDiv{
        width: 1200px;
        margin: 0 auto;
        .login{
            font-size: 30px;
            padding: 45px 0 58px 0;
            img{
                float: left;
                width: 70px;
            }
            span{
                letter-spacing: 1px;
                display: inline-block;
                padding-left: 26px;
                margin: 10px 0 0 28px;
                border-left: solid 1px #fff;
                float: left;
                height: 50px;
                line-height: 50px;
            }
            p{
                clear: both;
            }
        }
        .title{
            font-size: 18px;
            padding-bottom: 25px; 
            height: 26px;
            line-height: 26px; 
            a{
                color: #fff;
            }         
            p{
               float: left; 
               cursor: pointer;              
            }
            span{
                float: right;
                cursor: pointer;
            }
            .iconfont{
                font-size: 24px;
                margin-right: 10px;
                float: left;
            }
            div{
                clear: both;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/common/headerTail.vue